export default __webpack_public_path__ + "images/9f3dbc4aff62c1233f582dda92a44f5c-raffle_small.webp";